import { render } from "./AdminPending75Liquidations.vue?vue&type=template&id=7f7e9757"
import script from "./AdminPending75Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminPending75Liquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__